import { Button, ButtonProps } from "primereact/button";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Reduxstore";


interface ReusablePrimeButtonProps extends ButtonProps {
  allowedRoles?: string[]; // ✅ optional
}

const ReusablePrimeButton: React.FC<ReusablePrimeButtonProps> = ({
  allowedRoles,
  ...props
}) => {
  const userDetails = useSelector((state: RootState) => state.auth);

  // ✅ If allowedRoles is provided, check permission
  if (allowedRoles && allowedRoles.length > 0) {
    const hasAccess = userDetails?.role?.some((r: any) =>
      allowedRoles.includes(r.roleName)
    );
    if (!hasAccess) return null; // 🔒 Hide button if access denied
  }

  // ✅ If allowedRoles not passed, or access granted — show button
  return <Button {...props} />;
};

export default ReusablePrimeButton;